export default "/images/vendor/flag-icon-css/flags/1x1/cz.svg?1b3452b8ce83987fb494ea9ac5f49522";